import Rating from '@glass/web/components/TestimonialSection/Rating';
import { TOTAL_RATING } from '@glass/web/components/TestimonialSection/constants';
import Typography from '@glass/web/components/base/Typography';
import { MD } from '@glass/web/modules/theme/breakpointKeys';
import makeStyles from '@glass/web/modules/theme/makeStyles';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down(MD)]: {
      alignItems: 'flex-start',
    },
  },
  rating: {
    marginBottom: theme.spacing(1),
    alignItems: 'center',
    [theme.breakpoints.down(MD)]: {
      alignItems: 'flex-start',
    },
  },
}));

function TotalRating() {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Rating className={classes.rating} size="large" precision={0.1} value={TOTAL_RATING} />
      <Typography variant="h4">
        <b>{TOTAL_RATING}</b> stars from over <b>3,500</b> Google reviews
      </Typography>
    </div>
  );
}

export default TotalRating;
